//顶部tabbar
export const TOP_BAR_HEIGHT = 'TopBarHeight';

// 接口白名单，可以直接略过code校验
export const WHITE_API = new Set(['/login/loginByMobile']);
